import { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function SplitText({
  text = "",
  className = "",
  delay = 60,
  duration = 0.7,
  ease = "power3.out",
  tag = "span",
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const chars = el.querySelectorAll(".split-char");
    if (!chars.length) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        chars,
        { opacity: 0, y: 50, rotateX: -90 },
        {
          opacity: 1,
          y: 0,
          rotateX: 0,
          duration,
          ease,
          stagger: delay / 1000,
          scrollTrigger: { trigger: el, start: "top 92%", once: true },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, [text, delay, duration, ease]);

  const Tag = tag;
  const words = text.split(" ");

  return (
    <Tag
      ref={ref}
      className={className}
      style={{ display: "inline-block", perspective: "1000px" }}
    >
      {words.map((word, wi) => (
        <span key={wi} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
          {Array.from(word).map((ch, ci) => (
            <span
              key={ci}
              className="split-char"
              style={{ display: "inline-block", willChange: "transform, opacity" }}
            >
              {ch}
            </span>
          ))}
          {wi < words.length - 1 && (
            <span className="split-char" style={{ display: "inline-block" }}>
              {" "}
            </span>
          )}
        </span>
      ))}
    </Tag>
  );
}
